import { FormattedMessage } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'

function PurchaseContextChangedMessage() {
  return <div role="alert"><MessageBanner kind="warning">
    <FormattedMessage
      id="3F9uJ-nOaCluS877d1qE"
      defaultMessage="Your booking details changed. Review your selection and try again."
      description="Explains that prices, membership or other booking details changed during account access or payment selection so the visitor must review and retry"
    />
  </MessageBanner>
  </div>
}

export default PurchaseContextChangedMessage
